import { render, staticRenderFns } from "./add-channel-form-DVB-T.vue?vue&type=template&id=318d43f1&"
import script from "./add-channel-form-DVB-T.vue?vue&type=script&lang=ts&"
export * from "./add-channel-form-DVB-T.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports